module.exports = __webpack_public_path__ + "static/assets/710afc61cce8380eeb56abd43978c4f5.png";